
import { Card, Col, Form, Row } from 'antd'
import { ButtonBack, ButtonSubmit } from 'components/Common/Buttons';
import CustomCollapse from 'components/Common/CustomCollapse';
import SkeletonPage from 'components/Common/SkeletonPage';
import Error403 from 'components/Error/Error403'
import useAccessPermissionHook from 'hooks/useAccessPermissionHook';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useRoleRepo from 'services/repo/useRoleRepo';
// import useRoleRepo from "../../../services/repo/useRoleRepo";
import { INIT_ROLE, roleAtom } from 'store/Role/role';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import { checkErrorFormToOpenCollapse, setFieldValues } from 'utils/Helper';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';
import { CustomFormItemText, CustomFormItemSelectDropdown , CustomFormItemSwitch} from 'components/Common/CustomFormItemVertical';



export default function ManageRole() {
    const { roleId } = useParams();
    useTopbarTitleHooks(`${roleId ? "Edit" : "Create"} Role`);
    const { isLoading: isLoadingSave, create, update } = useRoleRepo(false);
    const { isLoading: isLoadingGetById, getRoleById } = useRoleRepo(false);
    const [dataField, setDataField] = useAtom(roleAtom)


    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [activeKey, setActiveKey] = useState(['1', '2']);
    const [errorList, setErrorList] = useState(false)

    const isLoadingPrivilege = useRef(true)
 
    const fetchCheckPrivilege = async () => {
        loadingToastId(Constant.message.loading, PRIVILEGE_ID.AddEditRole)
        dismissToast(PRIVILEGE_ID.AddEditRole)
        if (roleId) {
            await fetchGetRoleById(roleId);
        }
        isLoadingPrivilege.current = false
    }

    const fetchGetRoleById = async (id) => {
        let response = await getRoleById({ roleId: id });
         if (response?.detail=='OK' && response?.status === 200) {
                let data = response?.data;
                
                setFieldValues(form, "roleName", data?.roleName);
                setFieldValues(form, "status", String(data?.status).toLowerCase() === "true");

                setDataField({
                    roleId: data?.orgId,
                    roleName: data?.roleName,
                    status: data?.status
                });
        }
    };

    const validateList = () => {
       
    }

    const doSubmit = async () => {
        
    }

    const validateSubmit = () => {
        form.validateFields()
            .then((values) => {
                if (validateList()) {
                    doSubmit()
                } else {
                    errorToast(Constant.message.errorForm)
                }
            })
            .catch((errorInfo) => {
                
                errorToast(Constant.message.errorForm)
                if (checkErrorFormToOpenCollapse(errorInfo?.errorFields, [])) {
                    setActiveKey(prev => ([...new Set([...prev, '1'])]));
                }
                if (!validateList()) {
                    setActiveKey(prev => ([...new Set([...prev, '2'])]));
                }
            });
    }

    const handleFormSubmit = (e) => {
        e.preventDefault()
        CustomAlert.confirm({
            title: "Submit Role!",
            description: `Are you sure you want to submit this data?`,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "primary",
            onConfirmButton: () => validateSubmit()
        });
    }

    useEffect(() => {
        fetchCheckPrivilege()
        return () => {
             setDataField(INIT_ROLE);
        };
    }, [roleId])

    return (
        <div>
            <Card>
                <Form
                    name={`form-role`}
                    form={form}
                    layout='vertical'
                >
                    <Row gutter={[16]}>

                        <Col xs={24} sm={24}>
                            <Row gutter={[16]}>
                                <Col xs={24} sm={24} lg={12}>
                                    <CustomFormItemText
                                        nameFormItem="roleName"
                                        label="Name"
                                        placeholder='Fill in Role Name'
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                        value={dataField?.roleName}
                                        onChange={(e) => {
                                            setDataField(prev => ({
                                                ...prev,
                                                roleName: e.target.value
                                            }))
                                        }}
                                    />
                                </Col>
                                
                                 <Col xs={24} sm={24} lg={12}>
                                    <CustomFormItemSwitch
                                        nameFormItem="status"
                                        label="Is Active"
                                        value={dataField?.status}
                                        // isView={isView}
                                        onChange={(checked) => {
                                        setDataField(prev =>
                                            ({ ...prev, status: checked }))
                                        }}
                                    />
                                </Col>
                                
                            </Row>
                        </Col>

                       

                    </Row>

                    <div style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
                        <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.role.index)} disabled={isLoadingGetById || isLoadingSave} />
                        <ButtonSubmit
                            onClick={handleFormSubmit}
                            loading={isLoadingSave}
                            disabled={isLoadingGetById || isLoadingSave}
                        />
                    </div>
                </Form>
            </Card>
        </div>
    )

}
